export default __webpack_public_path__ + "images/mt-c91049a111e0a4dc2611b09a5a469c0b.svg";